<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Parámetros</span>
      </h5>
    </div>
      <div class="card" v-if="schoolModules.cafeteriaModule && [consts.rolesText.ADMIN, consts.rolesText.ADMIN_RESTAURANTE].includes(user.role)">
          <div class="card-header p-2 ml-2 mt-2">
            <h5>
              <strong>Cafetería</strong>
            </h5>
          </div>
          <div class="card-body pb-0">
            <div class="d-flex flex-nowrap">
              <div class="mr-2">
                <b-form-checkbox class="mt-2" v-model="params.massiveRecharge.functionCheck" name="check-button" switch @change="addParams(params.massiveRecharge.rechargeId, null, params.massiveRecharge.functionCheck, params.massiveRecharge.idParam, params.massiveRecharge.isParam)"> </b-form-checkbox>
              </div>
              <div>
                <label class="h6 mt-2 font-weight-bold">Función recarga masiva
                    <br>
                  <h6><small class="text-secondary">Permite recargar (saldo o productos por cantidad) a múltiples usuarios.</small></h6>
                </label>
              </div>
            </div>
            <div class="d-flex flex-nowrap">
              <div class="mr-2">
                <b-form-checkbox class="mt-2" v-model="params.inventory.inventoryCheck" name="check-button" switch @change="addParams(params.inventory.inventoryId, null, params.inventory.inventoryCheck, params.inventory.idParam, params.inventory.isParam)"></b-form-checkbox>
              </div>
              <div>
                <label class="h6 mt-2 font-weight-bold">Inventario restaurante/cafetería
                  <br>
                <h6><small class="text-secondary">Permite gestionar el inventario de manera eficiente, controlando la cantidad de productos disponibles para la venta.</small></h6>
                </label>
              </div>
            </div>
            <div class="d-flex flex-nowrap" v-if="params.inventory.inventoryCheck">
              <div class="mr-2">
                <b-form-checkbox class="mt-2" v-model="params.inventory.inventoryOrder.check" name="check-button" switch @change="addParams(params.inventory.inventoryOrder.orderId, null, params.inventory.inventoryOrder.check, params.inventory.inventoryOrder.idParam, params.inventory.isParam)"></b-form-checkbox>
              </div>
              <div>
                <label class="h6 mt-2 font-weight-bold">Orden de los productos
                  <br>
                    <h6><small class="text-secondary">Permite visualizar en función del orden de importancia establecido por la institución.</small></h6>
                </label>
              </div>
            </div>
            <div class="d-flex flex-nowrap">
              <div class="mr-2">
                <b-form-checkbox class="mt-2" v-model="params.combos.comboCheck" name="check-button" switch @change="addParams(params.combos.comboInfo.comboId, params.combos.comboInfo.comboName, params.combos.comboCheck, params.combos.comboInfo.idParam, params.combos.isParam)"></b-form-checkbox>
              </div>
              <div>
                <label class="h6 mt-2 font-weight-bold">Función producto por cantidad
                <h6><small class="text-secondary">Producto de adquisición por unidades, permitiendo tener el saldo del usuario por separado.</small></h6>
                </label>
              </div>
            </div>
            <div class="d-flex flex-nowrap" v-if="params.combos.comboCheck">
              <div class="ml-5">
                <div class="input-group d-md-flex align-items-center">
                  <label class="text-break my-auto mr-2">Nombre del producto por cantidad: </label>
                  <b-input class="w-auto" id="input-product" v-model="params.combos.comboInfo.comboName" placeholder="Ingrese el nombre del producto por cantidad"></b-input>
                </div>
                <h6><small class="text-secondary"> Establece el nombre del producto por cantidad.</small></h6>
              </div>
            </div>
            <div class="d-flex flex-nowrap">
              <div class="mr-2">
                <b-form-checkbox class="mt-2" v-model="params.notificationCafeteria.functionCheck" name="check-button" switch @change="addParams(params.notificationCafeteria.id, null, params.notificationCafeteria.functionCheck, params.notificationCafeteria.idParam, params.notificationCafeteria.isParam)"></b-form-checkbox>
              </div>
              <div>
                <label class="h6 mt-2 font-weight-bold">Notificación a usuarios (compras y recargas)
                  <br>
                <h6><small class="text-secondary">Permitir él envió de correos electrónicos con la información de la recarga o compra realizada por el usuario (Si es un estudiante, los padres también serán notificados).</small></h6>
                </label>
              </div>
            </div>
            <div class="d-flex flex-nowrap">
              <div class="mr-2">
                <b-form-checkbox class="mt-2" v-model="params.cashBox.functionCheck" name="check-button" switch @change="addParams(params.cashBox.id, null, params.cashBox.functionCheck, params.cashBox.idParam, params.cashBox.isParam)"></b-form-checkbox>
              </div>
              <div>
                <label class="h6 mt-2 font-weight-bold">Gestionar cajas
                  <br>
                  <h6>
                    <small class="text-secondary">
                      Permite realizar control del flujo de efectivo generado por las ventas de cada cajero. Proporciona un informe que agiliza el control y seguimiento, incluye el saldo al inicio de la jornada y el total recaudado durante el periodo en que la caja estuvo abierta.
                    </small>
                  </h6>
                </label>
              </div>
            </div>
            <div class="d-flex flex-nowrap">
              <div class="mr-2">
                <b-form-checkbox class="mt-2" v-model="params.credit.functionCheck" name="check-button" switch @change="addParams(params.credit.id, params.credit.value, params.credit.functionCheck, params.credit.idParam, params.credit.isParam)"></b-form-checkbox>
              </div>
              <div>
                <label class="h6 mt-2 font-weight-bold">Habilitar crédito
                  <br>
                  <h6>
                    <small class="text-secondary">Se ofrece la posibilidad de generar un saldo de crédito para los usuarios, el cual pueden decidir si activarlo desde la configuración de sus perfiles.
                      En el caso del rol de visitante, no se les permite acceder a esta función ni disponer de crédito.</small>
                  </h6>
                </label>
              </div>
            </div>
            <div class="d-flex flex-nowrap mt-2" v-if="params.credit.functionCheck">
              <div class="ml-5">
                <div class="input-group d-flex flex-column flex-sm-row">
                  <label class="text-break mr-2 md:mt-2">Limite del crédito: </label>
                  <b-form-group id="input-group-credit">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa fa-money text-blue" /></span>
                      </div>
                      <money v-model="params.credit.value" v-bind="money" style="font-size: 1.2em;" class="form-input"></money>
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="p-0 m-0">
              <b-button type="submit" variant="primary" class="float-right mr-3 mb-3 my-2" @click="updateParams(consts.params.IS_CAFETERIA)">Actualizar parámetros</b-button>
            </div>
          </div>
      </div>
      <div class="card" v-if="schoolModules.observerModule && [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO].includes(user.role)">
        <div class="card-header p-2 ml-2 mt-2">
          <h5>
            <strong>Observador</strong>
          </h5>
        </div>
        <div class="card-body pb-0">
          <div class="d-flex flex-nowrap">
            <div class="mr-2">
              <b-form-checkbox class="mt-2" v-model="params.notificationObserver.functionCheck" name="check-button" switch @change="addParams(params.notificationObserver.id, null, params.notificationObserver.functionCheck, params.notificationObserver.idParam, params.notificationObserver.isParam)"></b-form-checkbox>
            </div>
            <div>
              <label class="h6 mt-2 font-weight-bold">Notificación a usuarios por observaciones
                <br>
                <h6><small class="text-secondary">Realizar envió de correos electrónico a usuarios al realizar una anotación en el observador (Si es un estudiante, los padres también serán notificados).</small></h6>
              </label>
            </div>
          </div >
          <div class="p-0 m-0">
              <b-button type="submit" variant="primary" class="float-right mr-3 mb-3 my-2" @click="updateParams(consts.params.IS_OBSERVER)">Actualizar parámetro</b-button>
          </div>
        </div>
      </div>
      <div class="card" v-if="schoolModules.cafeteriaModule && user.role === consts.rolesText.ADMIN">
        <div class="card-header p-2 ml-2 mt-2">
          <h5>
            <strong>Pasarela de pagos</strong>
          </h5>
        </div>
        <div class="card-body pb-0">
          <div class="d-flex flex-nowrap">
            <div class="mr-2">
              <b-form-checkbox class="mt-2" v-model="params.onlineRecharge.functionCheck" name="check-button" switch @change="addParams(params.onlineRecharge.id, params.onlineRecharge.value, params.onlineRecharge.functionCheck, params.onlineRecharge.idParam, params.onlineRecharge.isParam)"></b-form-checkbox>
            </div>
            <div>
              <label class="h6 mt-2 font-weight-bold">Habilitar recargas por medio de ePayco</label>
            </div>
          </div>
          <div class="d-flex flex-nowrap mt-2" v-if="params.onlineRecharge.functionCheck">
            <div  class="ml-5">
              <div class="input-group d-flex flex-column flex-sm-row">
                <label class="text-break my-auto mr-2">Llave de E-payco:</label>
                <b-input class="w-auto m-0 p-0 pl-2" id="input-key" v-model="params.onlineRecharge.value" placeholder="Ingrese la llave generada en la pasarela de pago"></b-input>
              </div>
              <div>
                <h6><small class="text-secondary">Llave generada por ePayco para que el establecimiento comercial (Institución educativa) pueda realizar el recaudo.</small></h6>
              </div>
            </div>
          </div>
          <div class="p-0 m-0">
              <b-button type="submit" variant="primary" class="float-right mr-3 mb-3 my-2" @click="updateParams(consts.params.IS_EPAYCO)">Actualizar parámetro</b-button>
          </div>
        </div>
      </div>
      <div class="card" v-if="user.role === consts.rolesText.ADMIN">
        <div class="card-header p-2 ml-2 mt-2">
          <h5>
            <strong>Datos institución</strong>
          </h5>
        </div>
        <div class="card-body">
          <b-form-row class="mb-2">
            <b-col sm="12" md="4" lg="4" xl="3">
              <label class="h6 mt-2 font-weight-bold">Nombre de la institución:</label>
            </b-col>
            <b-col sm="12" md="6" lg="4" xl="3" class="ml-md-n3 ml-lg-n2 ml-xl-n5 col-sm-12 col-md-6 col-lg-4 col-xl-3">
              <b-input id="input-name" v-model="school.name" placeholder="Ingrese el nombre de la institución"></b-input>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="12" md="4" lg="4" xl="3">
              <label class="h6 mt-2 font-weight-bold">Teléfono:</label>
            </b-col>
            <b-col sm="12" md="6" lg="4" xl="3" class="ml-md-n3 ml-lg-n2 ml-xl-n5">
              <b-input id="input-phone" v-model="school.phone" placeholder="Ingrese el teléfono de la institución"></b-input>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="12" md="4" lg="4" xl="3">
              <label class="h6 mt-2 font-weight-bold">Correo electrónico:</label>
            </b-col>
            <b-col sm="12" md="6" lg="4" xl="3" class="ml-md-n3 ml-lg-n2 ml-xl-n5">
              <b-input id="input-email" v-model="school.email" placeholder="Ingrese el correo electrónico de la institución"></b-input>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-2">
            <b-col sm="12" md="4" lg="4" xl="3">
              <label class="h6 mt-2 font-weight-bold">Zona horaria:</label>
            </b-col>
            <b-col sm="12" md="6" lg="4" xl="3" class="ml-md-n3 ml-lg-n2 ml-xl-n5">
              <b-form-select v-model="school.timeZone" :options="timeZoneClient"></b-form-select>
            </b-col>
          </b-form-row>
        </div>
        <div class="p-0 m-0">
          <b-button type="submit" variant="primary" class="float-right mr-4 mb-3 mt-3" @click="updatedSchool()"> Actualizar datos</b-button>
        </div>
      </div>
      <div class="card" v-if="schoolModules.payrollModule">
        <div class="card-header p-2 ml-2 mt-2">
          <h5>
            <strong>Datos de la compañía</strong>
          </h5>
        </div>
        <div class="card-body">
          <b-form-row>
            <template>
              <basicSettings ref="settingsComponent" :idSchool="idSchool"/>
            </template>
          </b-form-row>
        </div>
        <div class="p-0 m-0">
          <b-button type="button" variant="primary" class="float-right mr-4 mb-3 mt-3" @click="updateNominaSettings()"> Actualizar datos</b-button>
        </div>
      </div>
    </div>
</template>
<script>
import apiClient from '@/services/axios'
import basicSettings from '@/components/custom/nomina/settings/basicSettings/basicSettings.vue'
import { mapState } from 'vuex'
import { consts, showErrorMessage } from '@/services/utilities'
import store from 'store'
import Swal from 'sweetalert2'
import { ToastFire, SwalFire } from '@/services/utilities/swal'
import apiClient2 from '@/services/axios/v2'
import { Money } from 'v-money'

export default {
  name: 'ManagementArea',
  components: {
    basicSettings, Money,
  },
  data() {
    return {
      loading: false,
      list: [
        { text: 'Cafetería', value: 'INVENTORY', collapsed: false },
        { text: 'Datos de la empresa', value: 'BASIC', collapsed: false },
      ],
      params: {
        combos: {
          comboCheck: false,
          comboInfo: {
            comboId: '',
            comboName: '',
            idParam: '',
          },
          isParam: consts.params.IS_CAFETERIA,
        },
        inventory: {
          inventoryCheck: false,
          inventoryId: '',
          inventoryOrder: {
            check: false,
            previousCheck: false,
            orderId: '',
            idParam: '',
          },
          isParam: consts.params.IS_CAFETERIA,
        },
        massiveRecharge: {
          functionCheck: false,
          rechargeId: '',
          idParam: '',
          isParam: consts.params.IS_CAFETERIA,
        },
        notificationCafeteria: {
          functionCheck: false,
          id: '',
          idParam: '',
          isParam: consts.params.IS_CAFETERIA,
        },
        notificationObserver: {
          functionCheck: false,
          id: '',
          idParam: '',
          isParam: consts.params.IS_OBSERVER,
        },
        onlineRecharge: {
          functionCheck: false,
          previousCheck: false,
          id: '',
          idParam: '',
          value: '',
          isInitialLoad: true,
          isParam: consts.params.IS_EPAYCO,
        },
        cashBox: {
          functionCheck: false,
          id: '',
          idParam: '',
          value: 0,
          isInitialLoad: true,
          isParam: consts.params.IS_CAFETERIA,
        },
        credit: {
          functionCheck: false,
          id: '',
          idParam: '',
          value: 0,
          isInitialLoad: true,
          isParam: consts.params.IS_CAFETERIA,
        },
      },
      school: {
        id: '',
        name: '',
        address: '',
        email: '',
        phone: '',
      },
      schoolModules: {
        academicModule: false,
        libraryModule: false,
        cafeteriaModule: false,
        treasuryModule: false,
        inventoryModule: false,
        attendanceModule: false,
        observerModule: false,
        payrollModule: false,
      },
      idSchool: null,
      inventory: false,
      // [0] = CAFETERIA, [1] = OBSERVER, [2] = E-PAYCO. (paramsIds AND sendParams)
      paramsIds: [[], [], []],
      sendParams: [[], [], []],
      isInitialLoad: true,
      timeZoneClient: Intl.supportedValuesOf('timeZone'),
      consts,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false,
      },
      creditTimer: '',
      isCredit: false,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    setData (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        if (data) {
          for (const param of data) {
            if (param.key === consts.params.COMBO) {
              this.params.combos.comboCheck = param.active
              this.params.combos.comboInfo.comboId = param.idSchoolParam
              this.params.combos.comboInfo.idParam = param.id
              this.params.combos.comboInfo.comboName = param.value
            } else if (param.key === consts.params.INVENTORY) {
              this.params.inventory.inventoryCheck = param.active
              this.params.inventory.inventoryId = param.idSchoolParam
              this.params.inventory.idParam = param.id
            } else if (param.key === consts.params.ORDER) {
              this.params.inventory.inventoryOrder.check = param.active
              this.params.inventory.inventoryOrder.previousCheck = param.active
              this.params.inventory.inventoryOrder.orderId = param.idSchoolParam
              this.params.inventory.inventoryOrder.idParam = param.id
            } else if (param.key === consts.params.MASSIVE_RECHARGE) {
              this.params.massiveRecharge.functionCheck = param.active
              this.params.massiveRecharge.rechargeId = param.idSchoolParam
              this.params.massiveRecharge.idParam = param.id
            } else if (param.key === consts.params.ONLINE_RECHARGE) {
              this.params.onlineRecharge.functionCheck = param.active
              this.params.onlineRecharge.previousCheck = param.active
              this.params.onlineRecharge.id = param.idSchoolParam
              this.params.onlineRecharge.idParam = param.id
              this.params.onlineRecharge.value = param.value
            } else if (param.key === consts.params.NOTIFICATION_CAFETERIA) {
              this.params.notificationCafeteria.functionCheck = param.active
              this.params.notificationCafeteria.id = param.idSchoolParam
              this.params.notificationCafeteria.idParam = param.id
            } else if (param.key === consts.params.NOTIFICATION_OBSERVER) {
              this.params.notificationObserver.functionCheck = param.active
              this.params.notificationObserver.id = param.idSchoolParam
              this.params.notificationObserver.idParam = param.id
            } else if (param.key === consts.params.CASH_BOX) {
              this.params.cashBox.functionCheck = param.active
              this.params.cashBox.id = param.idSchoolParam
              this.params.cashBox.idParam = param.id
              this.params.cashBox.value = param.value
            } else if (param.key === consts.params.CREDIT) {
              this.params.credit.functionCheck = param.active
              this.params.credit.id = param.idSchoolParam
              this.params.credit.idParam = param.id
              this.params.credit.value = param.value ?? 0
            }
          }
          this.params = {
            ...this.params,
          }
        }
      }
    },
    updatedSchool() {
      Swal.fire({
        title: 'Confirmar cambios',
        text: '¿Estás seguro de que deseas actualizar los datos de la institución?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, actualizar',
        cancelButtonText: 'No.',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient.patch(`/params/${this.school.id}/school-name/`, { sentParams: this.school }).then(response => {
            Swal.fire('Datos actualizados con éxito', '', 'success')
            this.loading = false
          }).catch(e => {
            Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
          })
        } else {
          this.loading = false
        }
      })
    },
    async updateParams(isParam) {
      if ((this.sendParams[0].length > 0 || this.isCredit) || this.sendParams[1].length > 0 || this.sendParams[2].length > 0) {
        if (isParam === consts.params.IS_CAFETERIA) {
          if (this.paramsIds.includes(this.params.credit.id)) {
            this.sendParams[0].map((element) => {
              if (element.id === this.params.credit.id && element.active) {
                if (Number(element.value) === 0) return ToastFire('warning', 'El crédito debe ser mayor a cero para habilitarlo o modificar el saldo de crédito.')
              }
            })
          }
          if (this.sendParams[0].length > 0) {
            const responseSwal = await SwalFire('Mensaje de confirmación', (this.sendParams.length > 1 ? '¿Quieres actualizar parametros?' : '¿Quieres actualizar el parámetro?'), 'warning', 'Si')
            if (responseSwal) {
              this.accessToken = store.get('accessToken')
              apiClient2.patch(`/schoolParam/school/${this.$store.state.user.idSchool}`, { sentParams: this.sendParams[0] }).then(response => {
                ToastFire('success', this.sendParams[0].length > 1 ? 'Parámetros actualizados con éxito' : 'Parámetro actualizado con éxito')
                this.paramsIds[0] = []
                this.sendParams[0] = []
                this.isCredit = false
                this.setData('', response.data.data)
              }).catch(error => {
                ToastFire('warning', showErrorMessage(error))
              })
            }
          } else {
            ToastFire('warning', 'No has realizado cambios.')
          }
        } else if (isParam === consts.params.IS_OBSERVER) {
          if (this.sendParams[1].length > 0) {
            const responseSwal = await SwalFire('Mensaje de confirmación', (this.sendParams[1].length > 1 ? '¿Quieres actualizar parametros?' : '¿Quieres actualizar el parámetro?'), 'warning', 'Si')
            if (responseSwal) {
              this.accessToken = store.get('accessToken')
              apiClient2.patch(`/schoolParam/school/${this.$store.state.user.idSchool}`, { sentParams: this.sendParams[1] }).then(response => {
                ToastFire('success', this.sendParams.length > 1 ? 'Parámetros actualizados con éxito' : 'Parámetro actualizado con éxito')
                this.paramsIds[1] = []
                this.sendParams[1] = []
                this.setData('', response.data.data)
              }).catch(error => {
                ToastFire('warning', showErrorMessage(error))
              })
            }
          } else {
            ToastFire('warning', 'No has realizado cambios.')
          }
        } else if (isParam === consts.params.IS_EPAYCO) {
          let isValid = true
          for (const element of this.sendParams[2]) {
            if (element.idParam === consts.ID_PARAM.ONLINE_RECHARGE) {
              isValid = false
            }
            if ((element.idParam === consts.ID_PARAM.ONLINE_RECHARGE && element.value) || (element.idParam === consts.ID_PARAM.ONLINE_RECHARGE && element.active !== true)) {
              isValid = true
            }
          }
          if (isValid) {
            const responseSwal = await SwalFire('Mensaje de confirmación', (this.sendParams[2].length > 1 ? '¿Quieres actualizar parametros?' : '¿Quieres actualizar el parámetro?'), 'warning', 'Si')
            if (responseSwal) {
              this.accessToken = store.get('accessToken')
              apiClient2.patch(`/schoolParam/school/${this.$store.state.user.idSchool}`, { sentParams: this.sendParams[2] }).then(response => {
                ToastFire('success', this.sendParams.length > 1 ? 'Parámetros actualizados con éxito' : 'Parámetro actualizado con éxito')
                this.paramsIds[2] = []
                this.sendParams[2] = []
                this.setData('', response.data.data)
              }).catch(error => {
                ToastFire('warning', showErrorMessage(error))
              })
            }
          } else {
            ToastFire('warning', this.sendParams.length === 0 ? 'No has realizado cambios.' : 'parámetro recarga en linea requiere el campo llave pasarela de pago')
          }
        }
      } else {
        ToastFire('warning', 'No has realizado cambios.')
      }
    },
    addParams(sendId, sendValue, sendActive, sendIdParam, isParam) {
      sendActive = !sendActive
      if (isParam === consts.params.IS_CAFETERIA) {
        if (this.paramsIds[0].indexOf(sendId) !== -1) {
          const fondParam = this.sendParams[0].find((element) => (element.id === sendId && [consts.ID_PARAM.CREDIT, consts.ID_PARAM.COMBO].includes(element.idParam)))
          if (fondParam && fondParam.active !== sendActive) {
            this.sendParams[0].map((element) => {
              if (element.id === sendId) {
                element.active = sendActive
              }
            })
          } else {
            const index = this.paramsIds[0].indexOf(sendId)
            this.paramsIds[0].splice(index, 1)
            this.sendParams[0] = this.sendParams[0].filter((element) => element.id !== sendId)
          }
        } else {
          this.paramsIds[0].push(sendId)
          this.sendParams[0].push({
            id: sendId,
            ...((sendValue || sendValue === '') && { value: sendValue }),
            active: sendActive,
            idParam: sendIdParam,
          })
        }
        if (this.paramsIds[0].includes(this.params.inventory.inventoryId)) {
          if (!this.paramsIds[0].includes(this.params.inventory.inventoryOrder.orderId) && this.paramsIds[0].includes(this.params.inventory.inventoryId) && this.params.inventory.inventoryOrder.idParam !== sendIdParam && sendActive === false) {
            this.paramsIds[0].push(this.params.inventory.inventoryOrder.orderId)
            this.sendParams[0].push({
              id: this.params.inventory.inventoryOrder.orderId,
              ...(sendValue || sendValue === '') && { value: sendValue },
              active: false,
              idParam: this.params.inventory.inventoryOrder.idParam,
            })
          } else if (this.paramsIds[0].includes(this.params.inventory.inventoryOrder.orderId) && this.params.inventory.inventoryOrder.idParam !== sendIdParam) {
            this.sendParams[0] = this.sendParams[0].map((element) => {
              if (element.id === this.params.inventory.inventoryOrder.orderId) {
                return { ...element, active: false }
              }
              return element
            })
          }
        }
      } else if (isParam === consts.params.IS_OBSERVER) {
        if (this.paramsIds[1].includes(sendId)) {
          const index = this.paramsIds[1].indexOf(sendId)
          this.paramsIds[1].splice(index, 1)
          this.sendParams[1] = this.sendParams[1].filter((element) => element.id !== sendId)
        } else {
          this.paramsIds[1].push(sendId)
          this.sendParams[1].push({
            id: sendId,
            ...((sendValue || sendValue === '') && { value: sendValue }),
            active: sendActive,
            idParam: sendIdParam,
          })
        }
      } else if (isParam === consts.params.IS_EPAYCO) {
        if (this.paramsIds[2].includes(sendId)) {
          const index = this.paramsIds[2].indexOf(sendId)
          this.paramsIds[2].splice(index, 1)
          this.sendParams[2] = this.sendParams[2].filter((element) => element.id !== sendId)
        } else {
          this.paramsIds[2].push(sendId)
          this.sendParams[2].push({
            id: sendId,
            ...((sendValue || sendValue === '') && { value: sendValue }),
            active: sendActive,
            idParam: sendIdParam,
          })
        }
        // Eliminar si se agrego el parametro recarga en linea en vacio
        if (this.paramsIds[2].includes(this.params.onlineRecharge.id) && this.params.onlineRecharge.value === '' && this.params.onlineRecharge.active) {
          const index = this.paramsIds[2].indexOf(sendId)
          this.paramsIds[2].splice(index, 1)
          this.sendParams[2] = this.sendParams[2].filter((element) => element.id !== sendId)
        }
      }
    },
    updateNominaSettings() {
      if (this.$refs.settingsComponent) {
        this.$refs.settingsComponent.save()
      }
    },
  },
  watch: {
    'params.combos.comboInfo.comboName': function () {
      if (this.isInitialLoad) {
        this.isInitialLoad = false
        return
      }
      if (this.paramsIds[0].includes(this.params.combos.comboInfo.comboId)) {
        this.sendParams[0].map((element) => {
          if (element.id === this.params.combos.comboInfo.comboId) {
            element.value = this.params.combos.comboInfo.comboName
          }
        })
      } else {
        this.paramsIds[0].push(this.params.combos.comboInfo.comboId)
        this.sendParams[0].push({
          id: this.params.combos.comboInfo.comboId,
          value: this.params.combos.comboInfo.comboName,
          active: true,
          idParam: this.params.combos.comboInfo.idParam,
        })
      }
    },
    'params.onlineRecharge.value': function () {
      if (this.params.onlineRecharge.isInitialLoad) {
        this.params.onlineRecharge.isInitialLoad = false
        return
      }
      if (this.params.onlineRecharge.value !== '') {
        if (this.paramsIds[2].includes(this.params.onlineRecharge.id)) {
          this.sendParams[2].map((element) => {
            if (element.id === this.params.onlineRecharge.id) {
              element.value = this.params.onlineRecharge.value
            }
          })
        } else {
          this.paramsIds[2].push(this.params.onlineRecharge.id)
          this.sendParams[2].push({
            id: this.params.onlineRecharge.id,
            value: this.params.onlineRecharge.value,
            active: true,
            idParam: this.params.onlineRecharge.idParam,
          })
        }
      } else if (this.paramsIds[2].includes(this.params.onlineRecharge.id) && this.params.onlineRecharge.value === '') {
        const index = this.paramsIds[2].indexOf(this.params.onlineRecharge.id)
        this.paramsIds[2].splice(index, 1)
        this.sendParams[2] = this.sendParams[2].filter((element) => element.id !== this.params.onlineRecharge.id)
      }
    },
    'params.credit.value': function () {
      if (this.params.credit.isInitialLoad) {
        this.params.credit.isInitialLoad = false
        return
      }
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => {
        this.isCredit = true
        if (this.paramsIds[0].includes(this.params.credit.id)) {
          this.sendParams[0].map((element) => {
            if (element.id === this.params.credit.id) {
              element.value = this.params.credit.value.toString()
            }
          })
        } else {
          this.paramsIds[0].push(this.params.credit.id)
          this.sendParams[0].push({
            id: this.params.credit.id,
            value: this.params.credit.value.toString(),
            active: true,
            idParam: this.params.credit.idParam,
          })
        }
      }, 500)
    },
  },
  async created() {
    this.accessToken = store.get('accessToken')
    this.idSchool = this.$store.state.user.idSchool
    apiClient.get('/schools/' + this.$store.state.user.idSchool).then(response => {
      this.school.id = response.data.id
      this.school.name = response.data.name
      this.school.address = response.data.address
      this.school.email = response.data.email
      this.school.phone = response.data.phone
      this.school.timeZone = response.data.timeZone
      this.schoolModules.academicModule = response.data.academicModule
      this.schoolModules.libraryModule = response.data.libraryModule
      this.schoolModules.cafeteriaModule = response.data.cafeteriaModule
      this.schoolModules.treasuryModule = response.data.treasuryModule
      this.schoolModules.inventoryModule = response.data.inventoryModule
      this.schoolModules.attendanceModule = response.data.attendanceModule
      this.schoolModules.observerModule = response.data.observerModule
      this.schoolModules.payrollModule = response.data.payrollModule
    }).catch(e => {
      console.log(e.response)
    })
    await apiClient2.get('/schoolParam').then(response => {
      this.setData('', response.data.data)
    }).catch(err => {
      this.setData(err, [])
    })
  },
}
</script>
